import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

export const conf = defineEntity({
  ...entityFactory("customer-tree"),
  // No `endpoint`: this config only supplies the route, role and title. The page reads
  // /api/v2/customers/tree directly.
  roleView: [ROLE.CUSTOMER_VIEW, ROLE.CUSTOMER_ADMIN],
  roleAdmin: [ROLE.CUSTOMER_ADMIN],
  baseRoute: "customer-tree",
  singularName: (t) => t("CustomerTree.title", "Customer tree"),
  name: (t) => t("CustomerTree.title", "Customer tree"),
});

export default conf;
